import React from 'react';
import { useState, useEffect } from 'react';
import '../styles/menu.css';

export default function Menu() {
	const [isOpen, setIsOpen] = useState(false);
	const [isVisible, setIsVisible] = useState(true);
	const [lastScrollY, setLastScrollY] = useState(0);

	useEffect(() => {
		const handleScroll = () => {
			const currentScrollY = window.scrollY;
			
			if (currentScrollY < lastScrollY) {
				setIsVisible(true);
			} else if (currentScrollY > lastScrollY && currentScrollY > 100) {
				setIsVisible(false);
			}
			
			setLastScrollY(currentScrollY);
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => window.removeEventListener('scroll', handleScroll);
	}, [lastScrollY]);

	const toggleMenu = () => {
		setIsOpen((open) => !open);
		console.log(isOpen);
	}

	return(
		<nav>
			<ul>
				<li className={`header ${isVisible ? 'visible' : 'hidden'}` }>
					<a href={`/`}>
						<span><h1>ERYE.FILM</h1></span>
					</a>
					<div className="header-flower">
						<a href={'/contact'}><img src={'../flowers/1.png'} className="flower" /></a>
						<a href={'/faq'}><img src={'../flowers/7.png'} className="flower" /></a>
						<a href={'/about'}><img src={'../flowers/2.png'} className="flower" /></a>
						<a href={'/info'}><img src={'../flowers/4.png'} className="flower" /></a>
						<a href={'/archive'}><img src={'../flowers/6.png'} className="flower" /></a>
					</div>
				</li>
				<li className={`flower-menu ${isOpen ? "open": ""}`} onClick={toggleMenu}>
	                <img src={require('../img/menu.png')} className="flower-menu-img" />
	            </li>
				<li>
					<ul className={`menu ${isOpen ? "open": ""}`}>
						<div className={`stupid-space ${isOpen ? "open": ""}`}></div>
		                <a href={`/archive`}>
		                	<li className="menu-item">&nbsp;ARCHIVE&nbsp;</li>
		                </a>
		                <a href={`/info`}>
		                    <li className="menu-item">&nbsp;INFO&nbsp;</li>
		                </a>
		                <a href={`/about`}>
		                	<li className="menu-item">&nbsp;ABOUT&nbsp;</li>
		                </a>
		                <a href={`/faq`}>
		                	<li className="menu-item">&nbsp;FAQ&nbsp;</li>
		                </a>
		                <a href={`/contact`}>
		                	<li className="menu-item">&nbsp;CONTACT&nbsp;</li>
		                </a>
		            </ul>
				</li>
			</ul>
        </nav>
	);
}